import { createRef, useContext } from "react";
import JSONSchemaForm from "@rjsf/core";
import useGet from "./useGet";
import useUpdate from "./useUpdate";
import { useNavigate } from "react-router-dom";
import { showSuccessMessage } from "@beeldit/core/helpers/messagesHelper";
import BeelditGenericForm from "@beeldit/core/components/BeelditGenericForm";
import { DetailsByCustomerActionContext } from "./DetailsByCustomerActionContext";

function useDetailsByCustomerAction(modelConfig: any, id: number): any {
  const contextInstance = useContext(DetailsByCustomerActionContext);

  const navigate = useNavigate();

  const detailsFunction = (id: any) => {
    navigate(`${modelConfig.detailsFunctionPath}${id}`);
  };

  const get = useGet(modelConfig);
  const getFunction = (id: number) => get(id);

  /**
   * Form store success function definition
   */
  const onSuccessUpdate = () => {
    showSuccessMessage("successfull_action");
    getFunction(id); // We pass the function to refresh the table on success
  };

  const update = useUpdate(modelConfig);
  const updateFunction = () => update(onSuccessUpdate);

  /** Edition element definition */
  const { element } = useContext(DetailsByCustomerActionContext);

  /**
   * Form Reference definition
   */
  const formRef = createRef<JSONSchemaForm>();

  const onSubmitFunction = () =>
    formRef.current?.formElement.current.requestSubmit(); //We pass the function for the submit of the modal

  /**
   * Form configuration definition
   */
  const formConfig = {
    formRef: formRef, // We pass the ref to the form
    onSubmit: () => {
      updateFunction();
    },
    element: element, // We pass the element to the form in order to render it in the modal form
    context: DetailsByCustomerActionContext,
    contextInstance: contextInstance,
  };

  const actionTemplate = (
    <BeelditGenericForm formConfig={formConfig} modelConfig={modelConfig} />
  );

  /** END EDIT FORM ACTION */

  return {
    detailsFunction,
    getFunction,
    onSubmitFunction,
    actionTemplate,
  };
}

export default useDetailsByCustomerAction;
